/* eslint-disable array-callback-return */
import React, { useState, useEffect } from "react";
import styled from "styled-components/macro";
import { NavLink, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import axios from "../../CustomAxios";
import Loading from "../components/Loading";

import {
  Breadcrumbs as MuiBreadcrumbs,
  Grid,
  Link,
  Paper as MuiPaper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Toolbar,
  Typography,
} from "@mui/material";

import { spacing } from "@mui/system";
import { withStyles } from "@mui/styles";

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

const StyledTableContainer = withStyles((theme) => ({
  root: {
    // width: "max-content",
  },
}))(TableContainer);

const Spacer = styled.div`
  flex: 1 1 100%;
`;

const ToolbarTitle = styled.div`
  min-width: 150px;
`;

function createData(
  job,
  customer,
  name,
  plate,
  cost,
  status,
  required,
  recieved,
  data
) {
  return {
    job,
    customer,
    name,
    plate,
    cost,
    status,
    required,
    recieved,
    data,
  };
}

const headCells = [
  { id: "job", alignment: "left", label: "Job ID" },
  { id: "customer", alignment: "left", label: "Customer Name" },
  { id: "name", alignment: "left", label: "Job Name" },
  { id: "plate", alignment: "left", label: "Plate Quantity" },
  { id: "cost", alignment: "left", label: "Job Cost" },
  { id: "recieved", alignment: "left", label: "Recieved Date" },
  { id: "required", alignment: "left", label: "Delivery Date" },
  { id: "status", alignment: "left", label: "Status" },
];

const getAllJobs = async (setRows, setLoader) => {
  try {
    const authData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + authData?.access_token,
      },
    };
    const { data } = await axios.get(
      `/api/v1/${authData?.type}/jobs?current_status=requested`,
      config
    );

    let rows = [];
    if (data.success) {
      const jobs = data.data.data;
      jobs.map((job) => {
        rows.push(
          createData(
            job.job_id,
            job.customer_company,
            job.name,
            job.plates.length,
            job.job_total_cost,
            job.current_status,
            job?.required_date,
            job?.received_date,
            job
          )
        );
      });
      setRows(rows);
      setLoader(false);
    }
  } catch (e) {
    setLoader(false);
    console.log(e);
  }
};

const EnhancedTableHead = (props) => {
  const { order, orderBy } = props;

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            // style={{ width: 100 }}
            key={headCell.id}
            align={headCell.alignment}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

const EnhancedTableToolbar = (props) => {
  // Here was 'let'
  const { numSelected } = props;

  return (
    <Toolbar>
      <ToolbarTitle>
        {numSelected > 0 ? (
          <Typography color="inherit" variant="subtitle1">
            {numSelected} selected
          </Typography>
        ) : (
          <Typography variant="h6" id="tableTitle">
            Requested Jobs
          </Typography>
        )}
      </ToolbarTitle>
      <Spacer />
      {/* <div>
        {numSelected > 0 ? (
          <Tooltip title="Delete">
            <IconButton aria-label="Delete" size="large">
              <ArchiveIcon />
            </IconButton>
          </Tooltip>
        ) : (
          <Tooltip title="Filter list">
            <IconButton aria-label="Filter list" size="large">
              <FilterListIcon />
            </IconButton>
          </Tooltip>
        )}
      </div> */}
    </Toolbar>
  );
};

function EnhancedTable({ rows }) {
  const navigate = useNavigate();
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("customer");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = rows.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  return (
    <div>
      <Paper>
        <EnhancedTableToolbar numSelected={selected.length} />
        <StyledTableContainer>
          <Table size="small">
            <EnhancedTableHead
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            <TableBody>
              {rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.id);

                  return (
                    <TableRow
                      hover
                      style={{ cursor: "pointer" }}
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      onClick={() =>
                        navigate("/dashboard/jobs/approve", {
                          state: { job: row.data },
                        })
                      }
                      key={`${row.id}-${index}`}
                      selected={isItemSelected}
                    >
                      <TableCell align="left">{row.job}</TableCell>
                      <TableCell align="left">{row.customer.name}</TableCell>
                      <TableCell align="left">{row.name}</TableCell>
                      <TableCell align="center">{row.plate}</TableCell>
                      <TableCell align="left">{row.cost}</TableCell>
                      <TableCell align="left">
                        {new Date(row?.recieved).toLocaleDateString() +
                          " " +
                          new Date(row?.recieved).toTimeString()}
                      </TableCell>
                      <TableCell align="left">
                        {new Date(row?.required).toLocaleDateString() +
                          " " +
                          new Date(row?.required).toTimeString()}
                      </TableCell>
                      <TableCell align="left">{row.status}</TableCell>
                    </TableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={8} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </StyledTableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}

function RequestedJobs() {
  const [loader, setLoader] = useState(true);
  const [rows, setRows] = useState([]);
  useEffect(() => {
    getAllJobs(setRows, setLoader);
  }, []);
  if (!loader) {
    return (
      <React.Fragment>
        <Helmet title="Alpha Plus" />
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              APPROVE JOBS
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Link component={NavLink} to="/dashboard/jobs">
                All Jobs
              </Link>
              <Typography>Approve Jobs</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid container spacing={6}>
          <Grid item xs={12}>
            <EnhancedTable rows={rows} />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

export default RequestedJobs;
